import { render, staticRenderFns } from "./MaterialsFilters.vue?vue&type=template&id=d63fe57c&"
import script from "./MaterialsFilters.vue?vue&type=script&lang=js&"
export * from "./MaterialsFilters.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports